import React, { useEffect } from 'react';
// import Spinner from '../../components/shared/spinner';
import BackgroundImage from '../../assets/images/call-back/callback-bg.png'
import Cloud from '../../assets/images/call-back/misc-images/cloud.png';
import api from '../../services/apiService'

import { UserManager, WebStorageStateStore } from 'oidc-client';
import { Flip, Slide } from 'react-reveal';
import { withRouter } from 'react-router-dom';
import { useDispatch } from "react-redux";
import getCompanies from '../../redux/actions/companies/getCompanies';
import appLS from '../../constants/local-storage';

function SigninCallback({ history }) {
  const dispatch = useDispatch();

  useEffect(() => {
    new UserManager({
      userStore: new WebStorageStateStore({ store: localStorage }),
      response_type: process.env.REACT_APP_RESPONSE_TYPE,
      response_mode: 'query'
    }).signinRedirectCallback().then(user => {
      // setting the access token when logged to the app 
      localStorage.setItem(appLS.user, JSON.stringify(user));
      api.setAccessToken();
      // getting companies
      dispatch(getCompanies()).then(_ => {
        history.push('/redirect-to-home');
      });
      // to fetch data user will be redirected to the following page. it dispatches the products action
    }).catch(function (e) {
      console.error(e);
    });
  }, [history, dispatch]);

  return (
    <>
      <div className="callback-wrapper">
        <Flip top cascade>
          <div className="info-container">
            {/* <Spinner /> */}
            <h3>Behandler din melding.</h3>
            <p>Du vil snart bli videresendt til UE Integrasjoner.</p>
          </div>
        </Flip>
        <div className="clouds-container">
          <Slide left big delay={100}>
            <img src={Cloud} alt="cloud" />
          </Slide>
          <Slide left big delay={600}>
            <img src={Cloud} alt="cloud" />
          </Slide>
          <Slide right big delay={300}>
            <img src={Cloud} alt="cloud" />
          </Slide>
          <Slide right big delay={800}>
            <img src={Cloud} alt="cloud" />
          </Slide>
          <Slide right big delay={700}>
            <img src={Cloud} alt="cloud" />
          </Slide>
        </div>
        <div className="image-container">
          <figure>
            <img src={BackgroundImage} alt="loading" />
          </figure>
        </div>
      </div>
    </>
  );
}

export default withRouter(SigninCallback);